import React from 'react'
import PropTypes from 'prop-types'
import { useWillPipe } from '@morningtrain/react-helpers'
import useForm from '../hooks/use-form'

function ResetFormOnPipe (props) {
  const { formRef } = props

  const form = useForm()

  useWillPipe((payload) => {
    return new Promise((resolve, reject) => {
      let formToReset = null

      if (formRef && formRef.current && typeof formRef.current.reset === 'function') {
        /// Support resetting native forms
        formToReset = formRef.current
      } else if (form && typeof form.reset === 'function') {
        /// Handle resetting form providing through context
        formToReset = form
      }

      if (formToReset !== null) {
        Promise.resolve(formToReset.reset())
          .then(() => {
            resolve(payload)
          })
          .catch(err => {
            reject(err)
          })
      } else {
        reject('Tried to reset form on pipe, but no form was found')
      }
    })
  })

  return null
}

ResetFormOnPipe.defaultProps = {
  formRef: null
}

ResetFormOnPipe.propTypes = {
  formRef: PropTypes.object
}

export default ResetFormOnPipe
